import React from 'react';
import About from '../components/About';
import NavBar from '../components/NavBar';
import { Container } from '../styles/home';
const AboutViews = ()=> {
  return (
   <Container>
    <NavBar/>
    <About/>
   </Container>
  );
}

export default AboutViews;